// 選択したタグをテキストボックスと相互反映

tag2text()
function tag2text() {
  const tags = document.getElementsByClassName('js-tagSelect')
  const searchBox = document.getElementById('search-tagSearch')
  if (!searchBox || !tags[0]) {
    return
  }

  window.addEventListener('change', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-tagSelect')) {
      tag2textBox(e.target)
    } else if (e.target.id === 'search-tagSearch') {
      textBox2tag(e.target)
    }
  })
  window.addEventListener('input', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-tagSelect')) {
      tag2textBox(e.target)
    } else if (e.target.id === 'search-tagSearch') {
      textBox2tag(e.target)
    }
  })

  // サジェスト検索の操作に追従する
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-search-insert')) {
      setTimeout(() => {
        textBox2tag(e.target)
      }, 300)
    }
  })

  // タグの変化をテキストボックスに反映
  function tag2textBox(item) {
    let list = input2list()
    if (item.checked) {
      list.push(item.value) // 配列の末尾に追加
    } else {
      // 配列から特定の要素を削除
      for (let index = 0; index < list.length; index++) {
        const text = list[index]
        if (text === item.value) {
          list.splice(index, 1) // 要素を削除
        }
      }
    }
    list = listFix(list)
    list2input(list)
    list2activeTag(list) // タグも同じものが複数ある可能性があるので更新
  }
  // テキストボックスの変化をタグに反映
  function textBox2tag() {
    let list = input2list()
    list2activeTag(list)
  }

  // 配列を整理する
  function listFix(list) {
    list = new Set(list) // 配列の重複を除去
    list = Array.from(list) // Setでオブジェクト型に変わったため配列に戻す
    list = list.filter((v) => v) // 配列の空要素を除去
    return list
  }
  // 検索キーワードを配列で返す
  function input2list() {
    const baseText = searchBox.value.replace(/　/g, ' ') // 全角スペースを半角にした検索キーワード
    let list = baseText.split(' ') // 配列に変換
    list = listFix(list) // 配列を整理する
    return list
  }
  // 配列を検索キーワードにセットする
  function list2input(list) {
    const text = list.join(' ') // 配列を文字列に変換
    searchBox.value = text
  }

  // 選択されているタグの値を配列で返す
  function activeTag2list() {
    let list = []
    for (const tag of tags) {
      list.push(tag.value) // 配列の末尾に追加
    }
    list = listFix(list) // 配列を整理する
    return list
  }

  // 配列を選択されているタグとして反映する
  function list2activeTag(list) {
    for (const tag of tags) {
      if (list.indexOf(tag.value) !== -1) {
        tag.checked = true
      } else {
        tag.checked = false
      }
    }
  }
}
